// dynamic route segments (`locale`, `slug`) must shouldnt ever be forwarded as query
// params. They already live in the path (`/[locale]/product/[slug]/...`) etc.
// next-intl can leak them into the query when a concrete pathname is paired
// with a leftover `params` object (e.g. locale switcher). Once present,
// `Object.fromEntries(searchParams)` keeps re-attaching them on every step.
const ROUTE_SEGMENT_QUERY_KEYS = new Set(["locale", "slug"]);

export const toForwardableQuery = (
  searchParams: URLSearchParams | Record<string, string | string[] | undefined>,
): Record<string, string> => {
  const entries =
    searchParams instanceof URLSearchParams
      ? Array.from(searchParams.entries())
      : Object.entries(searchParams).flatMap(([key, value]) => {
          if (value === undefined) return [];
          if (Array.isArray(value)) return value.map((entry) => [key, entry]);
          return [[key, value]];
        });

  const query: Record<string, string> = {};

  for (const [key, value] of entries) {
    if (ROUTE_SEGMENT_QUERY_KEYS.has(key)) continue;
    query[key] = value;
  }

  return query;
};

export const toForwardableQueryString = (
  searchParams: URLSearchParams | Record<string, string | string[] | undefined>,
): string => {
  return new URLSearchParams(toForwardableQuery(searchParams)).toString();
};
